import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import TopTraders from './top-traders';
import TopWins from './top-wins';
import ButtonsSelector from '../../../shared/buttons-selector/components/buttons-selector';
import { WIDGETS } from '../constants/widget-constants';
import { getCampaigns } from '../../campaigns/actions/campaigns-actions';

class Widgets extends Component {
  state = {
    selectedWidget: WIDGETS[0],
  };

  componentDidMount = () => {
    const { campaigns, getCampaigns } = this.props;

    if (isEmpty(campaigns)) {
      getCampaigns();
    }
  };

  onTypeChange = item => {
    this.setState({ selectedWidget: item });
  };

  render = () => {
    const { selectedWidget } = this.state;

    return (
      <div>
        <ButtonsSelector items={WIDGETS} selectedValue={selectedWidget} onClick={this.onTypeChange} />
        {selectedWidget === WIDGETS[0] && <TopTraders />}
        {selectedWidget === WIDGETS[1] && <TopWins />}
      </div>
    );
  };
}

const mapStateToProps = state => ({
  campaigns: state.campaignsReducer.campaigns,
});

const mapDispatchToProps = dispatch => ({
  getCampaigns: () => {
    dispatch(getCampaigns());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Widgets);



// WEBPACK FOOTER //
// ./src/app/main/widgets/components/widgets.jsx